import React, { useRef, memo } from 'react';
import classNames from 'classnames';

// Styled
import { WrapperButton, StyledI, WrapperIcon } from 'Components/flowChart/components/CopyBranchButton/index.style.ts';

const PATH = 'Components/flowChart/components/CopyBranchButton/index.js';

function CopyBranchButton({
	data = [],
	disabledCopy,
	use,
	allowCopyBranch = true,
	// droppableStyle = {},
	// nodeId,
	node,
	callback,
	onError = () => {},
	isViewMode,
}) {
	const buttonNodeRef = useRef();
	const noData = data && data.length ? false : true;

	const onClickCopyBranch = (evt) => {
		try {
			if (node && !disabledCopy) {
				callback(evt, node);
			}
		} catch (e) {
			onError(e, {
				component: PATH,
				action: 'onClickCopyBranch',
				args: {},
			});
		}
	};

	try {
		return (
			<div className={classNames('btn-copy-wrapper', { 'no-data': noData })} ref={buttonNodeRef}>
				<WrapperButton isViewMode={isViewMode}>
					{use === 'design' && allowCopyBranch && (
						<button className={classNames('btn-copy', { 'no-data': noData })} onClick={onClickCopyBranch}>
							<WrapperIcon>
								<StyledI disabled={disabledCopy} className="material-icons">
									content_copy
								</StyledI>
							</WrapperIcon>
						</button>
					)}
				</WrapperButton>
			</div>
		);
	} catch (e) {
		onError(e, {
			component: PATH,
			action: 'render -> CopyBranchButton',
			args: {},
		});
	}
}

export default memo(CopyBranchButton);
